import { Component, OnInit, ElementRef, ViewChild, EventEmitter, Output, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SiteStettingService } from 'src/app/core/services/site-stetting.service';
import { Location } from '@angular/common';
import { AppMessagesService } from 'src/app/core/services/app-messages.service';
import { AppConfigService } from 'src/app/core/services/app-config.service';
import { InMemoryService } from 'src/app/shared/in-memory-web-api/in-memory.service';
import { Router } from '@angular/router';
import { AppServiceService } from 'src/app/core/services/app-service.service';

@Component({
  selector: 'app-login-via-password',
  templateUrl: './login-via-password.component.html',
  styleUrls: ['./login-via-password.component.scss']
})

export class LoginViaPasswordComponent implements OnInit {
  passWordForm: FormGroup;
  showPopupCard: boolean = false;
  @Output() sendOtp = new EventEmitter<string>();
  @Input() capsOn = "";
  @Input() hebrewCharater = "";
  message:string = "";
  sitekey: string;
  CaptchaNeeded:boolean;
  resetPassword:string;
  updatePhone:string;
  links:any;
  service:any;
  loader:boolean = false;
  isValidFormSubmitted:boolean = false;
  title:string='כניסה עם קוד משתמש וסיסמה'
  button='כניסה'
  showUpdatePhone:boolean = false;
  constructor(
    private formBuilder: FormBuilder,private appConfigService:AppConfigService, private location: Location ,private _router :Router,
    private _siteSettingService: SiteStettingService , private appMessagesService :AppMessagesService, private appService: AppServiceService) { }

    
  get userName() {
    return this.passWordForm.controls.userName;
  }
  get password() {
    return this.passWordForm.controls.password;
  }
  
  


  ngOnInit(): void {

    if(window['_loginType']==window['_loginTypeUsernamePasswordSMSOTP']){
      this.title = 'הזדהות משרד החינוך'
      this.button = 'המשך'
      this.showUpdatePhone = true;
    }
    this.service = this.appConfigService.service;
    this.appService.componentName = 'login-via-password-component';
    if(this.appMessagesService.errorCode!=""){
      this.message = this.appMessagesService.returnErrorMessage(this.appMessagesService.errorCode.toString()); 
      this.appMessagesService.errorCode="";
    }
   

    this.appConfigService.getLinks().subscribe(
      (data) => {
        this.links = data;
      },
      (error)=>{
        //TODO
      })
    this.resetPassword = this.links.resetPassword;
    this.updatePhone = this.links.updateDetails;
    this.sitekey = window['_siteSettings'].recaptchaSiteKey;
    this.service.restartLogin().subscribe(data => {
      if (data)
      this.CaptchaNeeded = this._siteSettingService.CaptchaNeeded = data.isCaptchaNeeded;
    }, err => {
    });
    this.passWordForm = this.formBuilder.group({
      userName: new FormControl('', { validators: [Validators.required] }),
      password: new FormControl('', { validators: [Validators.required] }),
    });
    this.passWordForm.valueChanges.subscribe(value => {
      const userNameValue = value['userName'];
      const passwordValue = value['password']
      this.appService.setFieldStatus(userNameValue?.trim().length > 0 || passwordValue?.trim().length > 0);
    });
   }



  login(captchaResponse?: any) {
    this.isValidFormSubmitted = true;
    if (this.passWordForm.invalid) {
      grecaptcha.reset();
      document.getElementById("userName").focus();
       return;
    }
    this.loader = true;
    if(captchaResponse == undefined)
    captchaResponse = " ";
    this.service.loginWithIdAndPassword(this.passWordForm.value.userName, this.passWordForm.value.password , captchaResponse).subscribe(
      (data) => {
        this.CaptchaNeeded =this._siteSettingService.CaptchaNeeded = data.isCaptchaNeeded;
        if (data.isError == false ) { 
          if(data.isPasswordExpiring == true){
          window['_target'] = this.links.resetPassword;
        }
        if(window['_loginType'] == window['_loginTypeUsernamePasswordSMSOTP']){
          this._router.navigate(['codeOtp'], { skipLocationChange: true });
        }
          this.appService.redirectTourl();
        }
        else {
          this.message = this.appMessagesService.returnErrorMessage(data.errorCode);
          this.hebrewCharater="";
          this.isValidFormSubmitted = false;
          document.getElementById("userName").focus();
          this.passWordForm.reset();
          grecaptcha.reset();
          this.loader = false;
        }
      },
      err => {


      }) 
  }
  clearCursor(type: string) {
    if(this.isValidFormSubmitted == false && this.passWordForm.controls[type].value=='' ){
      this.passWordForm.controls[type].reset();
    }
     }

     
 
  openPopup() {
    this.showPopupCard = true;
  }
  closePopup() {
    this.showPopupCard = false;
  }
  clearDirective(){
    this.hebrewCharater="";
  }

  resetMassage(){
    this.message = "";
  }
}
